import { render, staticRenderFns } from "./WSelect.vue?vue&type=template&id=c7379374&scoped=true&lang=pug&"
import script from "./WSelect.vue?vue&type=script&lang=js&"
export * from "./WSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7379374",
  null
  
)

export default component.exports